<template>
<v-dialog :model-value="getNotifiDialog.actived" persistent max-width="640px">
  <v-card>
    <v-card-title class="bg-blue-darken-3"><h3>{{getNotifiDialog.title}}</h3></v-card-title>
      <v-card-text>
        <p :key="item.index" v-for="item in getNotifiDialog.body">
          {{item}}
        </p>
      </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" variant="text" @click="notificationDialogClick()">Entendido</v-btn>
      <slot></slot>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'NotificationDialog',
  computed: {
    ...mapGetters(['getNotifiDialog'])
  },
  methods: {
    notificationDialogClick () {
      this.$store.dispatch('setNotificationDialog', { actived: false })
    }
  }
}
</script>
